import { useCallback } from 'react'
import { useAuth } from 'hooks/UseAuth'

export const useIsNotSelf = () => {
  const auth = useAuth()

  return useCallback(
    (member: { id: number }) => {
      return auth?.id !== member.id
    },
    [auth],
  )
}
